import { useEffect, useState } from 'react';
import { Api } from 'lavva.exalushome';
import { IUpdatesService } from 'lavva.exalushome/build/js/Services/Updates/IUpdatesService';
import { UpdatesService } from 'lavva.exalushome/build/js/Services/Updates/UpdatesService';
import { useInstallationContext } from '../../../../../context/installation';
import { diffHours } from '../../../../../utils/helpers';
import { useExalusContext } from '../../../context';
import * as exalusStorage from '../../../storage';

export const useUpdateController = () => {
  const [updateControllerOpen, setUpdateControllerOpen] = useState<boolean>(false);
  const { selectedInstallationId } = useInstallationContext();
  const { synchronized, connected } = useExalusContext();

  const handleSaveControllerMemoryForInstallationId = () => {
    if (selectedInstallationId) {
      let updateControllerMemory = exalusStorage.getItem('updateControllerMemory');

      if (updateControllerMemory) {
        if (selectedInstallationId in updateControllerMemory) {
          updateControllerMemory[selectedInstallationId] = new Date();
        } else updateControllerMemory = { ...updateControllerMemory, [selectedInstallationId]: new Date() };
      } else updateControllerMemory = { [selectedInstallationId]: new Date() };

      exalusStorage.setItem('updateControllerMemory', updateControllerMemory);
    }
  };

  const checkControllerUpdateAvailability = async () => {
    const updateService = Api.Get<IUpdatesService>(UpdatesService.ServiceName);
    const result = await updateService.CheckControllerSoftwareUpdateAvailabilityAsync();

    handleSaveControllerMemoryForInstallationId();
    if (result === true) setUpdateControllerOpen(true);
  };

  useEffect(() => {
    if (!selectedInstallationId || !synchronized || !connected) return;
    const updateControllerMemory = exalusStorage.getItem('updateControllerMemory');

    if (updateControllerMemory) {
      if (selectedInstallationId in updateControllerMemory) {
        if (diffHours(new Date(updateControllerMemory[selectedInstallationId]), 24)) {
          checkControllerUpdateAvailability();
        }
      } else checkControllerUpdateAvailability();
    } else checkControllerUpdateAvailability();
  }, [selectedInstallationId, synchronized, connected]);

  return {
    updateControllerOpen,
    setUpdateControllerOpen,
    handleSaveControllerMemoryForInstallationId,
  };
};
